export default "__VITE_ASSET__c5b407a2__"